let value: number | null = null;
const listeners = new Set<() => void>();

export const eventDragStartStore = {
  get: () => value,
  set: (v: number | null) => {
    value = v;
    listeners.forEach((l) => l());
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  reset: () => {
    value = null;
    listeners.clear();
  },
};
